import { Avatar } from '@seek/avatar';
import { Bleed, Inline, Stack, Text } from 'braid-design-system';

import { TextSkeleton } from 'src/libs/TextSkeleton';

import { AvatarGroup } from '../AvatarGroup/AvatarGroup';
import { PreviousApplicationLayout } from '../PreviousApplicationLayout';
import { TimelineItem } from '../TimelineItem';

export const PreviousApplicationsSkeleton = () => (
  <PreviousApplicationLayout
    positionTitle={<TextSkeleton width="50%" height="medium" />}
    bucketAndAppliedDate={
      <Inline space="none" alignY="center">
        <TextSkeleton width="100px" height="small" />
        <Text tone="secondary" size="xsmall">
          {`\u00A0\u00A0`}•{`\u00A0\u00A0`}
        </Text>
        <TextSkeleton width="100px" height="small" />
      </Inline>
    }
    viewJobLinkAndAttachments={
      <Inline space="small">
        <TextSkeleton width="10%" height="medium" />
        <TextSkeleton width="10%" height="medium" />
        <TextSkeleton width="10%" height="medium" />
      </Inline>
    }
    applicationTimeline={<ApplicationTimelineSkeleton />}
    titleLabel="skeleton"
  />
);

export const ApplicationTimelineSkeleton = () => (
  <Stack space="small" align="left">
    <AvatarGroup
      loading
      id="avatar-group-skeleton"
      names={[]}
      size="xsmall"
      space="small"
    />

    <Stack space="xxsmall">
      <TimelineItem
        icon={
          <Bleed top="xxsmall">
            <Avatar size="xsmall" variant="icon" name="" loading />
          </Bleed>
        }
        date={<TextSkeleton width="15%" height="small" />}
        content={<TextSkeleton width="75%" height="large" />}
      />
      <TimelineItem
        isLast={true}
        icon={
          <Bleed top="xxsmall">
            <Avatar size="xsmall" variant="icon" name="" loading />
          </Bleed>
        }
        date={<TextSkeleton width="15%" height="small" />}
        content={<TextSkeleton width="75%" height="large" />}
      />
    </Stack>
  </Stack>
);
